import { z } from "zod";
//
// Read
//
/** A user's saved order + visibility for one design system in the workspace nav */
export const DTODesignSystemListViewItem = z.object({
    designSystemId: z.string(),
    sortOrder: z.number(),
    isVisible: z.boolean(),
});
/** Response carrying the user's saved list view for a workspace */
export const DTODesignSystemListViewResponse = z.object({
    designSystemListView: DTODesignSystemListViewItem.array(),
});
//
// Write
//
/** Replaces the user's entire saved list for the workspace (no auto-save) */
export const DTODesignSystemListViewPayload = z.object({
    designSystemId: z.string(),
    isVisible: z.boolean(),
}).array();
